/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Tools_TruncatedInputs */



/**
* | output |
* | --- |
* | "The model ran out of tokens before calling the tool, which is common for reasoning models. Tools stay on; switch them off if tool calls fail." |
*
* @param {Private_Models_Hint_Tools_TruncatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_tools_truncated = /** @type {((inputs?: Private_Models_Hint_Tools_TruncatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Tools_TruncatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dem Modell gingen die Tokens aus, bevor es das Tool aufrief – bei Reasoning-Modellen häufig. Tools bleiben an; schalten Sie sie ab, wenn Tool-Aufrufe scheitern.")
	return /** @type {LocalizedString} */ ("The model ran out of tokens before calling the tool, which is common for reasoning models. Tools stay on; switch them off if tool calls fail.")
});